import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import { TextLoader } from '~/components/Loaders'
import Interests from '~/components/Interests/Toggle'


export default class extends React.Component {
    static propTypes = {
		isSessionUser: PropTypes.bool,
		interests: PropTypes.array.isRequired,
		userInterests: PropTypes.array
	};

    static contextTypes = {
		store: PropTypes.object
	};

    render() {

		let contextProps = this.context.store.getState(),
			{ interests, userInterests, isSessionUser } = this.props,
			dispatch = isSessionUser ? this.context.store.dispatch : false;

		return (
			<div className="panel p20 mbot0 mbot20-xs" id="interestsPanel">

				<h3 className="mtop0 mbot20">Interests</h3>

                { !!userInterests.length || !!isSessionUser
            		? <Interests dispatch={dispatch} userInterests={userInterests} interests={interests} />
            		: <p className="text-center mtop30">No interests selected</p>
                }

            </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Body/components/Interests.jsx